import { data } from '../../svg/Solar/data';
import { makeIcon } from '../makeIcon';

export const Solar = makeIcon(data, 'solar', 'Solar');

export default Solar;
